<app-header></app-header>
 
<app-serviceprovide></app-serviceprovide>

<app-projects></app-projects>

<app-about-us></app-about-us> 

<app-certification></app-certification>

<app-callme></app-callme>
 
<app-footer></app-footer>
